import type {
  ApprovalAction,
  ApprovalType,
  ApprovalActor,
} from 'ui-product-approvals-common';
import { useGetApproversQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
import { useResolvedActors } from './useResolvedActors';
import { captureException } from '../utils/sentryUtils';

export interface UseApprovers {
  approvers: ApprovalActor[];
  isLoading: boolean;
  isError: boolean;
}

export const useApprovers = (
  approvalType: ApprovalType,
  approvalAction: ApprovalAction
): UseApprovers => {
  const {
    data: queryData,
    loading: queryLoading,
    error: queryError,
  } = useGetApproversQuery({
    variables: {
      approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
      approvalAction,
    },
    onError: (error) => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovers',
          approvalType,
          approvalAction,
        },
      });
    },
  });

  const { approvers, isLoading: isResolving } = useResolvedActors(
    queryData?.approvers ?? []
  );

  return {
    approvers,
    isLoading: queryLoading || isResolving,
    isError: Boolean(queryError),
  };
};
